import React from 'react';
import Icon from '../../../components/AppIcon';

const useCases = [
  {
    icon: 'TrendingUp',
    title: 'Marketing teams',
    description: 'Build lead-capture forms, compare variants, and follow the response journey with real-time analytics.',
    features: ['A/B testing', 'Conversion analytics', 'Conditional flows'],
  },
  {
    icon: 'Palette',
    title: 'Agencies',
    description: 'Create branded form experiences for different clients and manage the work from one shared platform.',
    features: ['White labelling', 'Custom domains', 'Unlimited paid seats'],
  },
  {
    icon: 'Workflow',
    title: 'Operations teams',
    description: 'Collect registrations, payments, applications, and internal requests without waiting for a developer.',
    features: ['Stripe payments', 'Webhooks', 'Exportable responses'],
  },
];


const TestimonialsSection = () => {
  return (
    <section id="testimonials" className="py-24 lg:py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-teal-50 border border-teal-200 rounded-full text-xs font-semibold text-teal-700 mb-5">
            <Icon name="Users" size={13} />
            <span>Built for growing teams</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-heading font-bold text-gray-900 leading-tight mb-4">
            One platform, different workflows
          </h2>
          <p className="text-lg text-gray-500">
            Start with the tools your team needs today, then add more capable workflows as your forms grow.
          </p>
        </div>

        {/* Audience use cases — no invented customer identities or results. */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {useCases?.map((useCase, i) =>
          <div
            key={useCase?.title}
            className={`rounded-2xl p-8 border transition-all duration-300 hover:shadow-lg hover:-translate-y-1 ${
            i === 1 ?
            'bg-[#0a1628] border-white/5 lg:scale-105' :
            'bg-white border-gray-100'}`
            }>

              <div className={`w-11 h-11 rounded-xl flex items-center justify-center mb-5 ${
                i === 1 ? 'bg-teal-500/15 text-teal-300' : 'bg-teal-50 text-teal-700'
              }`}>
                <Icon name={useCase.icon} size={20} />
              </div>

              <h3 className={`text-xl font-heading font-bold mb-3 ${i === 1 ? 'text-white' : 'text-gray-900'}`}>
                {useCase.title}
              </h3>
              <p className={`text-sm leading-relaxed mb-6 ${i === 1 ? 'text-gray-300' : 'text-gray-600'}`}>
                {useCase.description}
              </p>

              <ul className="space-y-3 pt-5 border-t border-gray-100/10">
                {useCase.features.map((feature) => (
                  <li key={feature} className={`flex items-center gap-2 text-sm ${i === 1 ? 'text-gray-300' : 'text-gray-600'}`}>
                    <Icon name="CheckCircle2" size={15} className={i === 1 ? 'text-teal-300' : 'text-teal-600'} />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </section>);

};

export default TestimonialsSection;